<template>
  <div class="custom-adasiq">
    <AdasIqEmbed height="calc(100vh - 170px)" />
  </div>
</template>
<script>
import AdasIqEmbed from '@/components/adas-iq/AdasIqEmbed.vue'
// ADAS IQ as its own page: ad-hoc questions and the user's chat history, not tied to a
// repair. The repair dialog has the pinned version (its "ADAS IQ" tab).
export default {
  name: 'AdasIqView',
  components: {
    AdasIqEmbed
  }
}
</script>
<style lang="scss" scoped>
.custom-adasiq {
  min-height: 420px;
}
</style>
